// extracted by mini-css-extract-plugin
export var icon = "_bj-3";
export var subtitle = "_bj-2";
export var title = "_bj-1";
export var value = "_bj-0";